/* @flow */
import React, { useContext, useState, memo } from 'react'
import S from './Header7.styled'
import THEME from './Header7.theme'
import ActionGetter from './Actions'
import NavBar from '@website/common/components/NavBar'
import BrowserBar from '@website/common/assets/Browser.svg'
import { validation } from './Header7.consts'
import { DispatchContext, EditingContext } from '@contexts'
import EditableContent from '@website/common/components/EditableContent'
import ControlsWithImageCropper from '@website/common/components/Controlled/ControlsWithImageCropper'
import Show from '@website/common/components/Show/Show'
import Image from '@website/common/components/Image'
import Buttons from '@website/common/components/Buttons'

const Header7 = memo(props => {
  const {
    data: {
      title,
      paragraph,
      titleAlignment,
      paragraphAlignment,
      logoSrc,
      logoColor,
      buttons,
      logoDimensions,
      webImgUrl,
      logoWidth,
      backgroundImgDimensions,
      backgroundImgUrl,
      webImgUrlDimensions,
      bgOverlayTransparency,
      imgCropParams
    }
  } = props
  const dispatcher = useContext(DispatchContext)
  const Actions = ActionGetter(dispatcher)
  const { isEditing } = useContext(EditingContext)
  const [navBarHeight, setNavBarHeight] = useState(0)

  return (
    <S.StyledContainer
      bgOverlayTransparency={bgOverlayTransparency}
      backgroundImgUrl={backgroundImgUrl}
      backgroundImgDimensions={backgroundImgDimensions}
      isEditing={isEditing}
    >
      <>
        <NavBar
          handleHeightChange={setNavBarHeight}
          theme={THEME}
          logoProps={{
            logoSrc,
            logoColor,
            logoWidth,
            logoSizes: logoDimensions
          }}
        />
        <S.WmCustomContainer topOffset={navBarHeight}>
          <Show when={[title, paragraph, buttons.length > 0]}>
            <S.HeaderContent>
              <EditableContent
                text={title}
                alignment={titleAlignment}
                as={S.Title}
                required={validation.title.required}
                maxCount={validation.headingMaxChar}
                className="WM_GLOBAL_heading"
                onChange={Actions.changeTitle}
                changeAlignment={Actions.changeTitleAlignment}
              />
              <EditableContent
                text={paragraph}
                alignment={paragraphAlignment}
                as={S.Description}
                maxCount={validation.paragraphMaxChar}
                className="WM_GLOBAL_paragraph"
                onChange={Actions.changeParagraph}
                changeAlignment={Actions.changeParagraphAlignment}
              />
              <Buttons data={buttons} />
            </S.HeaderContent>
          </Show>
          <S.WebpageWrap>
            <S.BrowserBar src={BrowserBar} alt="browser bar" />
            <ControlsWithImageCropper
              actions={Actions.mockupActions(webImgUrl)}
            >
              <Image
                as={S.Img}
                asProps={{ className: 'page-img', imgCropParams }}
                defaultImgSrc={webImgUrl}
                sizes={webImgUrlDimensions}
                alt="browser bar"
              />
            </ControlsWithImageCropper>
          </S.WebpageWrap>
        </S.WmCustomContainer>
      </>
    </S.StyledContainer>
  )
})

Header7.contextType = DispatchContext

export default Header7
